import RecaptchaHelper from "util/RecaptchaHelper";

export default class DelayedRecaptchaLoader {
    constructor($element) {
        this.$element = $element;
        this.enableFormJs = this.enableFormJs.bind(this);

        $(window).on('scroll', this.enableFormJs);
        this.enableFormJs();
    }

    enableFormJs() {
        if ($(window).scrollTop() < (this.$element.offset().top / 2)) {
            return;
        }

        this.bindEvents();

        $(window).off('scroll', this.enableFormJs);
    }

    bindEvents() {
        RecaptchaHelper.load();
    }
}